import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'firstcharpipe'
  })
  export class firstCharUpperPipe implements PipeTransform {

    constructor() { }
        transform(value:any) {
            if (value) {
                 let arr=value.split(' ');
                let string='';
                arr.forEach(word=>{
                    string=string+word.charAt(0).toUpperCase()+word.slice(1)+' ';
                });
                return string.trim();
            }
            return value;
        }
    
    }



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/_pipe/uppercase.pipe.ts